import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img 
              src="https://funaffairs.com/wp-content/uploads/2022/11/fun-affairs.png" 
              alt="Fun Affairs" 
              className="h-20 w-20 mb-6 rounded-full"
            />
            <p className="text-sm text-white/90 mb-4">
              Lehigh Valley's premier event entertainment rental company serving Allentown, Bethlehem, Easton and surrounding areas.
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/FunAffairs" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.google.com/search?q=Fun+Affairs" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors">
                <i className="ri-google-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-white/90 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-sm text-white/90 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/about" className="text-sm text-white/90 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/service-areas" className="text-sm text-white/90 hover:text-white transition-colors">Service Areas</Link></li>
              <li><Link to="/reviews" className="text-sm text-white/90 hover:text-white transition-colors">Reviews</Link></li>
              <li><Link to="/faq" className="text-sm text-white/90 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li><Link to="/bounce-house-rentals" className="text-sm text-white/90 hover:text-white transition-colors">Bounce House Rentals</Link></li>
              <li><Link to="/interactive-activities" className="text-sm text-white/90 hover:text-white transition-colors">Interactive Activities</Link></li>
              <li><Link to="/entertainment" className="text-sm text-white/90 hover:text-white transition-colors">Entertainment</Link></li>
              <li><Link to="/services" className="text-sm text-white/90 hover:text-white transition-colors">Party Games</Link></li>
              <li><Link to="/services" className="text-sm text-white/90 hover:text-white transition-colors">Fun Foods</Link></li>
              <li><Link to="/services" className="text-sm text-white/90 hover:text-white transition-colors">Photo Programs</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/90">600 Haymont Dr, Easton, PA 18045</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-fill text-lg flex-shrink-0"></i>
                <a href="tel:6102532835" className="text-sm text-white/90 hover:text-white transition-colors">(610) 253-2835</a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-fill text-lg flex-shrink-0"></i>
                <a href="mailto:Neal@FunAffairs.com" className="text-sm text-white/90 hover:text-white transition-colors">Neal@FunAffairs.com</a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-fill text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/90">Mon-Sun: 9:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-white/80 text-center md:text-left">
              © 2026 Fun Affairs. All Rights Reserved.
            </p>
            <p className="text-sm text-white/80 text-center md:text-right">
              Serving: Allentown, Bethlehem, Easton, Nazareth, Forks Township, Wind Gap, Pen Argyl, Bangor, Bath, Whitehall, Northampton, Hellertown PA & Phillipsburg NJ
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}